import { GoalCollectionSaveRequestDto } from '../dto/request/goal-collection-save-request.dto';
import { GoalCollectionUpdateRequestDto } from '../dto/request/goal-collection-update-request.dto';
import { GoalCollectionResponseDto } from '../dto/response/goal-collection-response.dto';
import { BaseLandscapeService } from '../../base-landscape.service';

class GoalCollectionService extends BaseLandscapeService {
  public async fetchGoalCollections(): Promise<GoalCollectionResponseDto[]> {
    const response =
      await this.get<GoalCollectionResponseDto[]>(`/goalcollection`);
    return response.data;
  }

  public async fetchGoalCollectionById(
    id: string
  ): Promise<GoalCollectionResponseDto> {
    const response = await this.get<GoalCollectionResponseDto>(
      `/goalcollection/${id}`
    );
    return response.data;
  }

  public async fetchGoalCollectionsByGoalId(
    id: string
  ): Promise<GoalCollectionResponseDto[]> {
    const response = await this.get<GoalCollectionResponseDto[]>(
      `/goalcollection/getbygoalid/${id}`
    );
    return response.data;
  }

  public async createGoalCollection(
    saveRequest: GoalCollectionSaveRequestDto
  ): Promise<GoalCollectionResponseDto> {
    const response = await this.post<GoalCollectionResponseDto>(
      `/goalcollection`,
      saveRequest
    );
    return response.data;
  }

  public async updateGoalCollection(
    updateRequest: GoalCollectionUpdateRequestDto
  ): Promise<GoalCollectionResponseDto> {
    const response = await this.put<GoalCollectionResponseDto>(
      `/goalcollection`,
      updateRequest
    );
    return response.data;
  }

  public async deleteGoalCollection(existingId: string): Promise<void> {
    await this.delete<void>(`/goalcollection/${existingId}`);
  }
}

const goalCollectionService = new GoalCollectionService();
export default goalCollectionService;
